import { ReactNode, useEffect, useState } from 'react';
import { FoldOutAnimation } from './TwoTilesFoldoutComponent.styles';

interface Props {
  show: boolean;
  children: ReactNode;
  callback: (show: boolean) => void;
  onAnimationEnd?: () => void;
  onOpenAnimationEnd?: () => void;
}

const Foldout = ({ show, children, callback, onAnimationEnd, onOpenAnimationEnd }: Props) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const handleAnimationEnd = () => {
    if (!show) {
      setRender(false);
      onAnimationEnd?.();
    } else {
      onOpenAnimationEnd?.();
    }
    callback(show);
  };

  return shouldRender ? (
    <FoldOutAnimation $show={show} onAnimationEnd={handleAnimationEnd}>
      {children}
    </FoldOutAnimation>
  ) : null;
};

export default Foldout;
